import { render } from "./ReservationHistoryView.vue?vue&type=template&id=c1967fa2&scoped=true"
import script from "./ReservationHistoryView.vue?vue&type=script&lang=js"
export * from "./ReservationHistoryView.vue?vue&type=script&lang=js"

import "./ReservationHistoryView.vue?vue&type=style&index=0&id=c1967fa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1967fa2"]])

export default __exports__